module.exports = "<div class=\"form-group row\">\r\n    <ixs-label label=\"{{label}}\"></ixs-label>\r\n    <div class=\"col-md-9\">\r\n        <div class=\"radio\">\r\n            <input type=\"radio\">\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/radiobutton/radiobutton.component.html
// module id = 1059
// module chunks = 22